import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid } from '@mui/material';
import { MenuWithId } from 'components';
import { useTranslation } from 'react-i18next';
import { DashboardHelpers } from 'utils';
import { useFields } from 'hooks';

const FieldDropdown = ({
  selectedField,
  setSelectedField,
  selectedProperty,
  setProperty,
  selectedOrganization,
  required,
}) => {
  const { t } = useTranslation();
  const { fields } = useFields();

  let filteredFields = [];
  if (!!selectedProperty && selectedProperty?.id !== DashboardHelpers.StatusCodes.NoPropertySelected) {
    filteredFields = DashboardHelpers.filteredFields(selectedProperty?.id, undefined, fields);
  } else {
    filteredFields = DashboardHelpers.filteredFields(undefined, selectedOrganization?.id, fields);
  }

  return (
    <Grid item xs={12} sm={6}>
      <Typography variant="subtitle2" gutterBottom component="div">
        {t('field') + (required ? ' *' : '')}
      </Typography>
      <MenuWithId
        placeholder="Field"
        menuItems={filteredFields}
        selectedItem={selectedField?.name}
        selectItem={(item) => {
          setSelectedField(item);
          setProperty(item?.property_id);
        }}
        inputProps={{
          maxLength: 24,
        }}
        disabled={filteredFields && filteredFields?.length === 0}
        size="normal"
      />
    </Grid>
  );
};

FieldDropdown.propTypes = {
  setSelectedField: PropTypes.func.isRequired,
  selectedField: PropTypes.object,
  selectedProperty: PropTypes.object,
  selectedOrganization: PropTypes.object,
  setProperty: PropTypes.func,
  required: PropTypes.bool,
};

FieldDropdown.defaultProps = {
  selectedField: undefined,
  selectedProperty: undefined,
  selectedOrganization: undefined,
  setProperty: () => {},
  required: false,
};
export default FieldDropdown;
